export default function useActionStation (editBookingStationTime, handlePlayers) {
  function stationAction (station, bookingStationTimeId) {
    editBookingStationTime(bookingStationTimeId, 'station', { id: station.id });
    handlePlayers();
  }

  return {
    stationAction,
  };
}
